<template>
    <div class="px-2 w-full md:w-9/12 lg:w-7/12 m-auto mt-12 ">
       <h1 class="mt-8 text-gray-400 font-bold text-2xl text-center">Invalid link 404 - Page not found</h1>
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'Home',
    components: {
  
    },
    async mounted(){
  
    },
    data () {
      return {
       
      }
    },
    methods: {
  
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>


// WEBPACK FOOTER //
// src/pages/PageNotFound.vue